import {useTranslation} from "react-i18next";

import './filter.css';

function FilterContainer({children}) {
  return <div className="c-filter_container">
    { children }
  </div>
}

function FilterDays({ set, value }){
  const { t } = useTranslation();

  function setValue(value) {
    set(value)
  }

  const filters = [{value: 1}, {value: 7}, {value: 30}];

  return (
    <div className="c-filter-days_container">
      <div className="c-filter-days_daysFilter">
        {
          filters.map(f => {
            const checked = f.value === value;

            return (
              <div key={f.value} className="c-days" onClick={() => setValue(f.value)}>
                <label className={checked ? "checked" : ""}>
                  { f.value } { t('j') }
                </label>
              </div>
            )
          })
        }
    </div>
  </div>
  );
}


function FilterGeo({ set, geo }){
  return <div className="c-filter-geo_container">
    <div className="c-filter-geo_inner">
      {
        geo ? <div className="c-filter-geo active" onClick={set}>{ geo.item }</div>
            : <div className="c-filter-geo">-</div>
      }
    </div>
  </div>
}


function FilterSearchMode({ mode, set }) {
  const { t } = useTranslation();

  return <div className="c-search-mode">
    <label className={mode === "all" ? "checked" : ""} onClick={() => set("all")}>
      {t('Derniers Contenus')}
    </label>
    <label className={mode === "focus" ? "checked" : ""} onClick={() => set("focus")}>
      {t('Focus')}
    </label>
  </div>
}

export { FilterDays, FilterGeo, FilterContainer, FilterSearchMode }
